export default function (alertCleared) {
  return alertCleared ? "disabled" : "secondary"
}



// WEBPACK FOOTER //
// ./src/components/Alert/getIconColor.js